import React from 'react';

import { CTA, ImageType } from 'utils/types';
import { DetailsSection } from '../../../components/PDP/DetailsSection';

export interface DetailsContainerProps {
  content: {
    listOfContentSections: {
      title: string;
      headline: string;
      subHeadline?: string;
      slug: string;
      description?: {
        description: string;
      };
      cta?: CTA;
      desktopImages?: Array<ImageType>;
      mobileImages?: Array<ImageType>;
      modalButtonText?: string;
      modalTitle?: string;
      embeddedVideoLink?: string;
      listOfContentSections?: Array<{
        title: string;
        description: {
          description: string;
        };
        image: {
          file: {
            url: string;
          };
        };
        desktopImages?: Array<ImageType>;
        mobileImages?: Array<ImageType>;
        cta?: CTA;
        listOfContentSections?: Array<{
          title: string;
        }>;
      }>;
    }[];
  };
}

export const DetailsContainer: React.FC<DetailsContainerProps> = ({
  content,
}) => {
  if (!content) return null;
  const { listOfContentSections } = content;
  const props = listOfContentSections.map(section => {
    return {
      title: section.title,
      slug: section.slug,
      headline: section.headline,
      subheadline: section.subHeadline,
      copy: section.description?.description,
      cta: section.cta,
      desktopImages: section.desktopImages,
      mobileImages: section.mobileImages,
      modalButtonText: section.modalButtonText,
      modalTitle: section.modalTitle,
      link: section.embeddedVideoLink,
      listOfContent: section.listOfContentSections?.map(section => ({
        title: section.title,
        description: section.description?.description,
        image: section.image?.file?.url,
        desktopImages: section.desktopImages,
        mobileImages: section.mobileImages,
        cta: section.cta,
        listOfContentSections: section.listOfContentSections,
      })),
    };
  });

  return <DetailsSection content={props} />;
};

export default DetailsContainer;
